import { graphql } from "@/lib/gql/__generated__/gql";

export const DayTripPlanI18nUpdateMutation = graphql(/* GraphQL */ `
	mutation DayTripPlanI18nUpdate(
		$input: PlanI18nInput!
		$dayTripPlanCustomMailSettingI18nInput: PlanCustomMailSettingI18nInput!
	) {
		planI18nUpdate(input: $input) {
			userErrors
			planI18n {
				id
				lang
				hotelID
				planID
				name
				mainTarget
				article {
					bucket
					key
					region
					mimeType
					fileName
				}
				articleTitle
				emailTemplateReservation {
					atCreated
					atUpdated
					atCanceled
					atCin
				}
				questions {
					questionID
					required
					questionType
					question
					options
				}
			}
		}
		planCustomMailSettingI18nUpdate(input: $dayTripPlanCustomMailSettingI18nInput) {
			userErrors
			planCustomMailSettingI18n {
				id
				planID
				forReservation {
					atCreated {
						text
						override
					}
					atUpdated {
						text
						override
					}
					atCanceled {
						text
						override
					}
					atCheckInBefore_00days {
						text
						shouldSendEmail
						override
					}
					atCheckInBefore_01days {
						text
						shouldSendEmail
						override
					}
					atCheckInBefore_07days {
						text
						shouldSendEmail
						override
					}
					atCheckOutAfter_01days {
						text
						shouldSendEmail
						override
					}
				}
			}
		}
	}
`);
